import { Component, inject, input } from '@angular/core';
import { ButtonModule, ButtonSeverity } from 'primeng/button';
import { CommonModule } from '@angular/common';
import { MenuItem } from 'primeng/api';
import { injectDispatch } from '@ngrx/signals/events';
import { DialogModule } from 'primeng/dialog';
import { IconComponent } from '@navstation-portal/shared/ui/components';
import { IconNames, IconName } from '@navstation-portal/shared/data-model/ui';
import {
  offshoreReportEvents,
  OffshoreReportStore,
} from '@navstation-portal/reporting/data-access/offshore-report';
import { ActivatedRoute } from '@angular/router';

interface ButtonItem extends MenuItem {
  label: string;
  icon: IconName;
  severity?: ButtonSeverity;
  disabledFunction?: () => boolean;
  loadingFunction?: () => boolean;
  action?: () => void;
}

@Component({
  selector: 're-form-actions-footer',
  templateUrl: './form-actions-footer.component.html',
  imports: [CommonModule, ButtonModule, DialogModule, IconComponent],
})
export class FormActionsFooterComponent {
  route = inject(ActivatedRoute);
  offshoreReportDispatch = injectDispatch(offshoreReportEvents);
  offshoreReportStore = inject(OffshoreReportStore);

  isDeleteDialogVisible = false;
  isDrawerOpen = input<boolean>(false);
  reportId: string | null = this.route.snapshot.paramMap.get('reportId');

  items: ButtonItem[] = [
    {
      label: 'Delete',
      icon: IconNames.TrashAlt,
      action: () => this.deleteClicked(),
    },
    {
      label: 'Save',
      icon: IconNames.Save,
      loadingFunction: () => this.offshoreReportStore.savingReport(),
      action: () => this.saveClicked(),
    },
    {
      label: 'Submit',
      severity: 'primary',
      disabledFunction: () => !this.offshoreReportStore.vm().isFormValid,
      icon: IconNames.ArrowRightToBracket,
      styleClass: 'bg-[#027DA2]',
      action: () => this.submitClicked(),
    },
  ];

  saveClicked() {
    if (!this.reportId) return;
    this.offshoreReportDispatch.saveReport(this.reportId);
  }

  submitClicked() {
    if (!this.reportId) return;
    this.offshoreReportDispatch.submitReport(this.reportId);
  }

  deleteClicked() {
    this.isDeleteDialogVisible = true;
  }

  deleteReport() {
    if (!this.reportId) return;
    this.offshoreReportDispatch.deleteReport(this.reportId);
    this.isDeleteDialogVisible = false;
  }
}
